import { OutboundEmail } from "@zickko/shared";

type Props = {
  email: OutboundEmail;
  onSelectEmail: () => void;
};

export const OutboundEmailListItemWidget = (props: Props) => {
  const { email, onSelectEmail } = props;

  const snippet = "No preview available";

  const handleEmailClick = () => {
    onSelectEmail();
  };

  return (
    <div className="email-list-item-widget-container" onClick={handleEmailClick}>
      <div className="email-list-item-widget">
        <div className="heading">
          <div className="sender">{email.from}</div>
          <div className="time">9 months ago</div>
        </div>
        <div className="subject">{email.subject}</div>
        <div className="mail-snippet">{snippet} . . . </div>
        <div className="tags">
          <div className="meeting-tag">meeting</div>
          <div className="work-tag">work</div>
          <div className="important-tag">important</div>
        </div>
      </div>
    </div>
  );
};
